import type { LabelScaleAdapterId } from './labelScaleExport';

export type ScaleProtocol = 'mock' | 'toledo' | 'bizerba';

/** Wire-format preset id. Brand names are aliases only (UI labels). */
export type ScaleWirePreset = ScaleProtocol;

export const SCALE_WIRE_PRESETS: Array<{
  id: ScaleWirePreset;
  label: string;
  /** Brand aliases shown in support copy — not code forks. */
  brandAliases: string[];
  adapterId: 'mock' | 'ascii_kg_line';
}> = [
  {
    id: 'mock',
    label: 'Prueba',
    brandAliases: [],
    adapterId: 'mock',
  },
  {
    id: 'toledo',
    label: 'ASCII kg (Toledo y similares)',
    brandAliases: ['Toledo'],
    adapterId: 'ascii_kg_line',
  },
  {
    id: 'bizerba',
    label: 'ASCII kg (Bizerba y similares)',
    brandAliases: ['Bizerba'],
    adapterId: 'ascii_kg_line',
  },
];

export type { LabelScaleAdapterId };

export type BranchScaleConfig = {
  enabled: boolean;
  /** Preset de cable / adapter (historial: se guardaba como protocol). */
  protocol: ScaleProtocol;
  comPort: string;
  agentUrl: string;
  /**
   * Fase A: export PLU a archivo (etiquetadora). No es peso en vivo ni push serial.
   * Persistido por sucursal en AsyncStorage junto al resto del scale config.
   */
  labelScaleSyncEnabled: boolean;
  labelExportAdapter: LabelScaleAdapterId;
};

export const DEFAULT_BRANCH_SCALE_CONFIG: BranchScaleConfig = {
  enabled: false,
  protocol: 'mock',
  comPort: '',
  agentUrl: 'http://127.0.0.1:9310',
  labelScaleSyncEnabled: false,
  labelExportAdapter: 'systel_csv',
};

export type LiveScaleWeight = {
  grams: number;
  kg: number;
  stable: boolean;
  source: string;
  waiting?: boolean;
  message?: string;
};

export type LiveScaleWeightResult =
  | { ok: true; reading: LiveScaleWeight }
  | { ok: false; error: string };

export type ScaleAgentHealthResult =
  | {
      ok: true;
      service: string;
      port: number;
      scaleDefaultProtocol?: string;
      scalePortEnv?: string | null;
      serialportAvailable?: boolean;
    }
  | { ok: false; error: string };
